import numeral from 'numeral';

const keys = (t) => [
    {
        key: 'sumImpressions',
        label: t('discover.countries.chart.sumImpressions'),
        icon: 'search',
    },
    {
        key: 'avgCTR',
        label: t('discover.countries.chart.avgCTR'),
        format: '0.00%',
        render: (data) => numeral(data * 100).format('0.00'),
        yAxisID: 'y1',
        icon: 'ctr',
    },
    {
        key: 'pages',
        label: t('discover.countries.chart.pages'),
        format: '0.0',
        yAxisID: 'y2',
        icon: 'pagev-view',
    },
    {
        key: 'sumClicks',
        label: t('discover.countries.chart.sumClicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
];

export default keys;
